import { ImageLockIcon } from './ImageLockIcon';

/**
 * author: Simran
 * id 77796DB4-93FF-45E6-AC26-AE74713E6758
 * name image-lock
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-lock.svg
 * tags
 * - Lock 
 * - Photography 
 */
export const ImageSecureIcon = ImageLockIcon;
export default ImageSecureIcon